import { STUDY_HALL_MODIFY } from "../actions/studyhallActions"

const initialState = {
  lessonsActivity: [],
  isLessonActivitiesUpdating: false,
  isLessonActivitiesFetched: false,
  course: {},
  isFetchedCourse: false,
  subCourses: [],
  isFetchingSubCourses: false,
  isFetchedSubCourses: false,
  lessons: [],
  isLessonsFetched: false,
  practices: [],
  isPracticesFetched: false,
  isFetchedItemBank: false,
  itemBanks: {},
  isFetchedQuestionItems: false,
  questionItems: {},
  students: [],
  isStudentsFetched: false,
  urlParams: {},
  error: null,
  isFetchingPassage: false,
  passages: {},
  fetchingPassageError: null,
  videoStats: {},
  allLessonsFetching: false,
  allLessonsFetched: false,
  allLessonsFetchedError: false,
  currentProgram: null,

  activeLesson: null,
  studyHallLessons: {},
  isStudyHallUpdating: false
}

export default function studyHallReducer(state = initialState, action) {
  switch (action.type) {
    case STUDY_HALL_MODIFY:
      return Object.assign({}, state, action.payload)

    default:
      return state
  }
}
